/**
 * Detects macOS so shortcut hints can show ⌘/⌥ instead of Ctrl/Alt. Falls back
 * to non-Mac rendering in non-browser environments (e.g. SSR, tests).
 */
export function getIsMacPlatform(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent);
}
